'use strict';

import settings from '../settings';
import store from '../store';
import { PLACEHOLDER_IMAGE_ORANGE, timeout } from '../utils/common';
import { AppStoreTypes } from '../store/modules/app';
import { HttpContext } from '../utils/httpContext';
import { HirFunctions } from '../functions/HirFunctions';
import cloneDeep from 'lodash/cloneDeep';

class HirService {
  async GetKategoriak() {
    const url = settings.baseUrl + 'Api/Hir/GetKategoriak';
    const result = await HttpContext.post({ url });
    store.dispatch(AppStoreTypes.hirKategoriak.set, {
      value: result,
    });

    return result;
  }
  async GetHirek({
    kategoriaId,
    szerzoId,
    utolsoHirId,
    superAdminFl,
    keresoszoveg,
    cikkekhez,
  }) {
    const url = settings.baseUrl + 'Api/Hir/GetHirek';
    let data = {
      kategoriaId,
      szerzoId,
      utolsoHirId,
      mennyiseg: 65000,
      superAdminFl,
      keresoszoveg,
      cikkekhez,
    };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async EditHir({ id }) {
    const url = settings.baseUrl + 'Api/Hir/EditHir';
    let data = { id };
    let result = null;
    // await timeout(1000);
    // if (!id) {
    //   result = {
    //     Id: null,
    //     Szerzo: null,
    //     Kategoria: null,
    //     Ismerteto: '',
    //     Cim: '',
    //     MegjelenesDatuma: new Date().toISOString(),
    //     Kep: '',
    //     Tartalom: '',
    //     ArchivFl: false,
    //   };
    // } else {
    //   // prettier-ignore
    //   result =  {
    //       Id: id,
    //        Szerzo: {
    //          Id: 7,
    //          Text: 'Debrecen',
    //        },
    //        Kategoria: {
    //          Id: 63,
    //          Text: 'Tájékoztatók',
    //        },
    //        Cim: 'Elkezdődött a fogvatartottak oltása',
    //        Ismerteto: 'Elkezdődött a fogvatartottak oltása és ...',
    //        MegjelenesDatuma: '2020-05-01T00:00:00',
    //        Kep: PLACEHOLDER_IMAGE_ORANGE,
    //        Tartalom: '<h2 style=\"margin-left:0px;\">Cim1</h2><h3>Cim2</h3><h4>Cim3</h4><p>&nbsp;</p><h3>Betűtípus</h3><p><strong>Félkövér</strong>, <i>dőlt</i>, <u>aláhúzott</u>, <span style=\"color:hsl(0,75%,60%);\">narancs1</span>, <span style=\"background-color:hsl(30,75%,60%);\">narancs2</span>,</p><h3>Bekezdés</h3><p>Alap</p><p style=\"margin-left:40px;\">Első</p><p style=\"margin-left:80px;\">Második</p><h3>Igazítás</h3><h4>Bal</h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur accumsan purus non neque fermentum, a aliquam est mattis. Phasellus varius, ante posuere pretium auctor, magna odio viverra est, lacinia ultricies magna sapien quis augue. Praesent sit amet vestibulum lectus, nec rhoncus arcu. Nunc ut risus bibendum, finibus massa vel, molestie libero. In feugiat arcu et molestie bibendum. Proin laoreet, nibh quis feugiat consequat, augue lectus tincidunt odio, vel placerat lacus magna eget nisi. Aenean tristique feugiat erat quis pharetra. Morbi aliquam mi vitae nulla commodo, sit amet venenatis libero condimentum.</p><h4>Jobb</h4><p style=\"text-align:right;\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur accumsan purus non neque fermentum, a aliquam est mattis. Phasellus varius, ante posuere pretium auctor, magna odio viverra est, lacinia ultricies magna sapien quis augue. Praesent sit amet vestibulum lectus, nec rhoncus arcu. Nunc ut risus bibendum, finibus massa vel, molestie libero. In feugiat arcu et molestie bibendum. Proin laoreet, nibh quis feugiat consequat, augue lectus tincidunt odio, vel placerat lacus magna eget nisi. Aenean tristique feugiat erat quis pharetra. Morbi aliquam mi vitae nulla commodo, sit amet venenatis libero condimentum.</p><h4>Közép</h4><p style=\"text-align:center;\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur accumsan purus non neque fermentum, a aliquam est mattis. Phasellus varius, ante posuere pretium auctor, magna odio viverra est, lacinia ultricies magna sapien quis augue. Praesent sit amet vestibulum lectus, nec rhoncus arcu. Nunc ut risus bibendum, finibus massa vel, molestie libero. In feugiat arcu et molestie bibendum. Proin laoreet, nibh quis feugiat consequat, augue lectus tincidunt odio, vel placerat lacus magna eget nisi. Aenean tristique feugiat erat quis pharetra. Morbi aliquam mi vitae nulla commodo, sit amet venenatis libero condimentum.</p><h4>Sorkizárt</h4><p style=\"text-align:justify;\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur accumsan purus non neque fermentum, a aliquam est mattis. Phasellus varius, ante posuere pretium auctor, magna odio viverra est, lacinia ultricies magna sapien quis augue. Praesent sit amet vestibulum lectus, nec rhoncus arcu. Nunc ut risus bibendum, finibus massa vel, molestie libero. In feugiat arcu et molestie bibendum. Proin laoreet, nibh quis feugiat consequat, augue lectus tincidunt odio, vel placerat lacus magna eget nisi. Aenean tristique feugiat erat quis pharetra. Morbi aliquam mi vitae nulla commodo, sit amet venenatis libero condimentum.</p><h3>Listák</h3><ol><li>Első</li><li>Második<ol><li>Harmadik</li></ol></li></ol><p>&nbsp;</p><ul><li>Első</li><li>Második<ul><li>Harmadik</li></ul></li></ul><h3>Hr</h3><hr><h3>Idézet</h3><blockquote><p>Valami baj van</p><p>Én</p></blockquote><h3>Link</h3><p><a href=\"https://ckeditor.com/docs/ckeditor5/latest/features/link.html#demo-2\">Link doc</a></p><h3 style=\"margin-left:0px;\">Képek</h3><figure class=\"image image-style-align-center\"><img src=\"https://data-flair.training/blogs/wp-content/uploads/sites/2/2018/07/Spring-Security-01-1.jpg\"><figcaption>Teszt</figcaption></figure><p>&nbsp;</p><figure class=\"image\"><img src=\"https://data-flair.training/blogs/wp-content/uploads/sites/2/2018/07/Spring-Security-01-1.jpg\"><figcaption>Teszt</figcaption></figure><h2 style=\"margin-left:0px;\">Egy media embed</h2><figure class=\"media\"><div data-oembed-url=\"https://www.youtube.com/watch?v=iltpQyVp2xI\"><div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://www.youtube.com/embed/iltpQyVp2xI\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen=\"\"></iframe></div></div></figure><h2>Table</h2><figure class=\"table\"><table><thead><tr><th rowspan=\"2\">&nbsp;</th><th rowspan=\"2\">☕️ Espresso</th><th colspan=\"2\">🥛 Milk</th><th rowspan=\"2\">🚰 Water</th></tr><tr><th>Steamed</th><th>Foam</th></tr></thead><tbody><tr><th>Cappuccino</th><td>✅ yes</td><td>✅ yes</td><td>✅ yes</td><td>❌ no</td></tr><tr><th>Macchiato</th><td>✅ yes</td><td>❌ no</td><td>✅ yes</td><td>❌ no</td></tr><tr><th>Latte</th><td>✅ yes</td><td>✅ yes</td><td>❌ no</td><td>❌ no</td></tr><tr><th>Americano</th><td>✅ yes</td><td>❌ no</td><td>❌ no</td><td>✅ yes</td></tr></tbody></table></figure>',
    //        ArchivFl: false,
    //       };
    // }
    result = await HttpContext.post({ url, data });
    HirFunctions.ModifyFormDataFromServer(result);
    return result;
  }
  async SaveHir({ data }) {
    const url = settings.baseUrl + 'Api/Hir/SaveHir';
    let result = await HttpContext.post({ url, data });
    // let result = cloneDeep(data);
    // await timeout(1000);
    // if (!result.Id) {
    //   result.Id = 12;
    // }
    HirFunctions.ModifyFormDataFromServer(result);
    return result;
  }
  async UploadFiles({ formData }) {
    const url = settings.baseUrl + 'Api/Hir/UploadFiles';
    let data = formData;
    let result = await HttpContext.post({
      url,
      data,
      options: { fileUpload: true },
    });
    return result;
  }
  async GetHirStatuszok() {
    const url = settings.baseUrl + 'Api/Hir/GetHirStatuszok';

    let result = await HttpContext.post({
      url,
    });

    store.dispatch(AppStoreTypes.hirStatuszok.set, { value: result });
    return result;
  }
  async HirTorlese({ hirId }) {
    const url = settings.baseUrl + 'Api/Hir/HirTorlese';
    let data = { hirId };
    let result = await HttpContext.post({
      url,
      data,
    });
    return result;
  }
  async GetHirekForSelect({ keresoszoveg }) {
    const url = settings.baseUrl + 'Api/Hir/GetHirekForSelect';
    let data = { keresoszoveg };
    let res = [];
    for (let i = 0; i < 50; i++) {
      res.push({ Id: i, Text: keresoszoveg + ' találat' });
    }
    await timeout(1000);
    return res;
    let result = await HttpContext.post({
      url,
      data,
    });
    return result;
  }
  async CikkMegosztas(id) {
    const url = settings.baseUrl + 'Api/Hir/CikkMegosztas';
    let data = { id };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async GetHirekOlvasottsaga() {
    const url = settings.baseUrl + 'Api/Hir/GetHirekOlvasottsaga';

    let result = await HttpContext.post({
      url,
    });
    return result;
  }
}

let instance = new HirService();
export { instance as hirService };
